export default {
  getCep: state => state.cep,
  getAddress: state => state.address,
  getNumber: state => state.number,
  getNoNumber: state => state.noNumber,
  getNeighborhood: state => state.neighborhood,
  getState: state => state.state,
  getCity: state => state.city,
  getComplements: state => state.complements,
  getNoComplement: state => state.noComplement,
  getAddressNote: state => state.addressNote,
  getFullAddress: state => {
    return {
      cep: state.cep,
      address: state.address,
      number: state.number,
      noNumber: state.noNumber,
      neighborhood: state.neighborhood,
      state: state.state,
      city: state.city,
      complements: state.complements,
      noComplement: state.noComplement,
      addressNote: state.addressNote
    }
  }
}
